export const STATUS_META = {
  verde: { hex: "#10B981", bg: "#ECFDF5", text: "#047857", border: "#A7F3D0", name: "Verde" },
  amarillo: { hex: "#F59E0B", bg: "#FEF3C7", text: "#B45309", border: "#FDE68A", name: "Amarillo" },
  rojo: { hex: "#EF4444", bg: "#FEF2F2", text: "#B91C1C", border: "#FECACA", name: "Rojo" },
  gris: { hex: "#6B7280", bg: "#F3F4F6", text: "#374151", border: "#E5E7EB", name: "Gris" },
};

export const STATUS_ORDER = ["verde", "amarillo", "rojo", "gris"];

const PAYMENT_STYLES = [
  { bg: "#F1F5F9", text: "#1E293B" }, // Slate
  { bg: "#ECFDF5", text: "#065F46" }, // Emerald
  { bg: "#FFF7ED", text: "#9A3412" }, // Amber
  { bg: "#F0F9FF", text: "#075985" }, // Sky
  { bg: "#F0FDFA", text: "#0F766E" }, // Teal
  { bg: "#F3F4F6", text: "#374151" }, // Cool gray
];

export const paymentStyle = (method, methods = []) => {
  const idx = methods.indexOf(method);
  return PAYMENT_STYLES[(idx >= 0 ? idx : 5) % PAYMENT_STYLES.length];
};

export const formatBytes = (bytes) => {
  if (!bytes) return "0 B";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB", "TB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(1))} ${sizes[i]}`;
};

export const formatDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("es-ES", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return iso;
  }
};

export const isImage = (ct) => (ct || "").startsWith("image/");
export const isPdf = (ct) => (ct || "").includes("pdf");

export const formatMoney = (amount, currency = "USD") => {
  const n = Number(amount) || 0;
  try {
    return new Intl.NumberFormat("es-ES", {
      style: "currency",
      currency,
      maximumFractionDigits: 2,
    }).format(n);
  } catch {
    return `${n.toFixed(2)} ${currency}`;
  }
};
